// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CheckboxCardContract = contract({
  name: "CheckboxCard",
  description: "Multi-select where each option is a whole selectable card (add-ons, feature toggles, opt-ins). The whole card is the control, so focus and the checked state live on the card surface. Standalone (not in a group). Static content only — never nest an interactive control inside. For a plain checkbox + label row use Field instead.",
  import: "@gradeui/ui",
  aliases: ["checkbox card","selectable card","multi-select card","add-on card","feature card","opt-in card"],
  composesWith: ["Badge (in aside)","MediaSurface (custom children)","Stack / Grid (laying out several)"],
  props: {
  "checked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "standard checkbox state",
  },
  "defaultChecked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "standard checkbox state",
  },
  "onCheckedChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "standard checkbox state",
  },
  "label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "title line",
  },
  "description": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "secondary line",
  },
  "aside": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot before the indicator (a Badge, price, hint)",
  },
  "hideIndicator": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the check; selection shown by the card border + background",
  },
  "indicatorPosition": {
      schema: z.enum(["leading", "trailing"]).optional(),
      design: "knob",
      description: "default trailing",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "arbitrary static content instead of label/description",
  },
  },
});
